export const ActionTypes = {
    LINK: 'link',
    SHOW_WORK_DETAILS: 'showWorkDetails',
    CURRENT_MASK_LINK: 'currentMaskLink',
    PREV_MASK: 'PREV_MASK',
    NEXT_MASK: 'NEXT_MASK',
    CURRENT_MASK_LINK_REQUEST: 'currentMaskLinkRequest',
    PREV_MASK_REQUEST: 'prevMaskRequest',
    NEXT_MASK_REQUEST: 'nextMaskRequest',
    START_FILTER: 'START_FILTER',
    STOP_FILTER: 'STOP_FILTER'
};
